let dd = require('ES/lib/dd');
let _ = require('ES/lib/lodash');
let radio = require('ES/lib/radio');
let esUtils = require('ES/utils/esUtils');
let Constants = require('../../../utils/Constants');
let FormMixin = require('ES/widgets/forms/FormMixin');
let RadioMixin = require('ES/utils/RadioMixin');
let AuthedUserSession = require("../../../utils/AuthedUserSession");

let Form = dd.createClass({
  mixins: [FormMixin, RadioMixin],
  getInitialState() {
    return {advanced_expanded: false};
  },
  componentWillMount() {
    let self = this;
    self.radio = {
      'EventSearchAside_open': function (action) {
        if (action === 'show_advanced') {
          self.setState({advanced_expanded: true});
        }
      }
    };
  },
  getInitialValues(props) {
    let query = props.query;
    if (!query) {
      return null;
    }
    return {
      searchterm: query.searchterm || null,
      deepsearch: !!query.deepsearch,
      includecanceled: _.isArray(query.exclude_event_types) && !_.includes(query.exclude_event_types, Constants.EVENT_STATUSES.canceled),
      cross_companies: !!query.cross_companies,
      datelessonly: !!query.datelessonly,
      futureonly: !!query.futureonly,
      marketplaceonly: !!query.marketplaceonly,
      speaker_select: _.isArray(query.sids) && query.sids.length > 0 ? _.first(query.sids) : -1,
      company_ids: _.get(AuthedUserSession, ["activeCompanyIds"])
    };
  },
  buildFields() {
    let my_speaker_names_by_sid = this.props.my_speaker_names_by_sid;

    let fields = {
      searchterm: {
        type: 'text',
        placeholder: 'Search',
        validate: function () {
          return true;//accepts searches w/o a query
        }
      },
      deepsearch: {
        label: 'deep search',
        type: 'checkbox'
      },
      includecanceled: {
        label: 'include canceled',
        type: 'checkbox'
      },
      datelessonly: {
        label: 'only dateless events',
        type: 'checkbox'
      },
      futureonly: {
        label: 'only future events',
        type: 'checkbox'
      },
      // cross_companies: {
      //   label: 'other companies',
      //   type: 'checkbox'
      // }
    };
    if (!AuthedUserSession.is_privatelabel) {
      fields.marketplaceonly = {
        label: 'marketplace only',
        type: 'checkbox'
      };
    }
    if (AuthedUserSession.is_privatelabel) {
      fields.cross_company = {
        label: 'other companies',
        type: 'checkbox'
      };
    }

    if (_.keys(my_speaker_names_by_sid).length > 1) {
      fields.speaker_select = {
        type: 'select',
        placeholder: '-- all speakers --',
        options: my_speaker_names_by_sid,
        validate: function () {
          return true;//optional
        }
      };
    }
    return fields;
  },
  __toggleAdvanced: esUtils.wrapPreventDefault(function () {
    this.setState({advanced_expanded: !this.state.advanced_expanded});
  }),
  __open_n_show_advanced: esUtils.wrapPreventDefault(function () {
    radio('EventSearchAside_open').broadcast('show_advanced');
    setTimeout(function () {
      radio('EventSearchAside_open').broadcast('show_advanced');
    }, 100);//need to broadcast again after it's visible so that it'll be listening this time
  }),
  __changeTriggersSearch: _.debounce(function () {
    this._form_onSubmit({preventDefault: _.noop});
  }, 1000),
  onFormChanged(field_path, new_value) {
    if (field_path !== 'searchterm') {
      this.__changeTriggersSearch();
    }
  },
  render() {
    let fields = this.buildFields();
    let errors = this.state.errors || {};
    let advanced_expanded = this.state.advanced_expanded;
    let mini_form = this.props.mini_form;
    let status_text = this.props.status_text;

    return dd.form({role: 'search', onSubmit: this._form_onSubmit},
      dd.div({className: 'form-group' + (errors['searchterm'] ? ' has-error' : ''), style: {marginBottom: 0}},
        dd.div({className: 'input-group'},
          this._form_buildInput(fields.searchterm, 'searchterm'),
          dd.span({className: 'input-group-btn'},
            dd.button({type: 'submit', className: 'btn btn-default'}, dd.i({className: 'fa fa-search'})),
            mini_form ? dd.button({
                className: 'btn btn-default',
                onClick: this.__open_n_show_advanced
              },
              dd.i({className: 'fa fa-gear'})
            ) : null
          )
        )
      ),
      mini_form ? null : dd.div({style: {marginTop: 5}},
        dd.span({className: 'pull-right'},
          status_text
        ),
        dd.a({href: '#', onClick: this.__toggleAdvanced},
          'advanced ', dd.i({className: 'fa fa-caret-' + (advanced_expanded ? 'up' : 'down')})
        ),
        advanced_expanded ? dd.div(null,
          dd.div(null,
            _.map(_.filter(_.keys(fields), function (name) {
              return fields[name].type === 'checkbox';
            }), function (name) {
              return dd.div({className: 'checkbox', key: name},
                this._form_buildInput(fields[name], name)
              );
            }, this),
            dd.div({className: 'clearfix'})
          ),
          fields.speaker_select ? this._form_buildInput(fields.speaker_select, 'speaker_select') : null
        ) : null
      )
    );
  }
});

module.exports = dd.createClass({
  __onSubmit(data) {
    let q = {
      searchterm: data.searchterm,
      deepsearch: !!data.deepsearch,
      marketplaceonly: !!data.marketplaceonly,
      datelessonly: !!data.datelessonly,
      cross_companies: !!data.cross_companies,
      company_ids: data.company_ids,
      futureonly: !!data.futureonly,
      exclude_event_types: [Constants.EVENT_STATUSES.zimbra]
    };
    if (data.speaker_select > 0) {
      q.sids = [data.speaker_select];
    } else if (this.props.mini_form && this.props.default_filter_to_sid > 0) {
      q.sids = [this.props.default_filter_to_sid];
    }
    if (!data.includecanceled) {
      q.exclude_event_types.push(Constants.EVENT_STATUSES.canceled);
    }
    radio('EventSearchAside_search').broadcast(q);
  },
  render() {
    let {results, loading, error_msg} = this.props;

    let status_text = null;
    if (error_msg) {
      status_text = 'error';
    } else if (loading) {
      status_text = 'searching...';
    } else if (_.isArray(results)) {
      if (_.size(results) === 1) {
        status_text = "1 result";
      } else if (_.size(results) > 1) {
        status_text = _.size(results) + " results";
      } else {
        status_text = 'no results';
      }
    }

    return Form({
      query: this.props.query,
      status_text: status_text,
      onSubmit: this.__onSubmit,
      mini_form: this.props.mini_form,
      my_speaker_names_by_sid: this.props.my_speaker_names_by_sid
    });
  }
});


// WEBPACK FOOTER //
// ./src/components/main_view/calendar_area/SearchForm.js